<template>
    <div>
        <b-modal id="cost-unit-draft-detail-modal" hide-footer size="xl" title="Details Schadenpositionsentwurf"
            :visible="isModalOpen" @hide="reset()" @show="loadCostUnitDraft">
            <div v-if="isLoading" class="d-flex justify-content-center pt-1">
                <csp-loading-indicator/>
            </div>
            <div v-else>
                <b-card class="mb-4 info-card">
                    <b-row>
                        <b-col v-for="(value, key) in costUnitDraft" :key="key" cols="4">
                            <div class="info-card-element">
                                <label>
                                    {{ labels[key] || key }}
                                </label>
                                <div class="value">
                                    {{ formatters[key] ? formatters[key](value) : value }}
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="4">
                            <div class="info-card-element">
                                <label>
                                    {{ labels['hide'] || 'hide' }}
                                </label>
                                <div class="value">
                                    <csp-hide-for-group
                                        :default-value="hideForGroupValues"
                                        :options="hideForGroupOptions"
                                        :record-id="recordId"/>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import Container from '@services/Container';
    import '@desktop/scss/components/record/document-upload-modal.scss';
    import {formatDate, formatDateTime} from '@js/functions/date';
    import {formatCurrencyCents} from '@js/functions/format';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'CostUnitDraftDetailModal',
        props: {
            hideForGroupOptions: {
                type: Array,
                default: null,
            },
            costUnitDraftId: {
                type: Number,
                default: null,
            },
            isModalOpen: {
                type: Boolean,
                default: false,
            },
            recordId: {
                type: Number,
                required: true,
            },
        },
        emits: ['close'],
        data() {
            return {
                costUnitDraft: {},
                isLoading: true,
                hideForGroupValues: [],
                shouldShowDeletionModal: false,
                labels: {
                    costUnitDraftId: 'ID (Entwurf)',
                    receipt: 'Beleg Nr.',
                    costUnitText: 'Bezeichnung',
                    source: 'Quelle',
                    insuranceFigure: 'Bezifferungsart / Vorsteuerabzug',
                    amountNet: 'Forderung (netto)',
                    amountGross: 'Forderung (brutto)',
                    vatRate: 'USt.',
                    amountVat: 'USt.-Betrag',
                    amountCopayment: 'Selbstbeteiligung',
                    dateReceipt: 'beziffert am',
                    paymentComment: 'Bemerkung',
                    dateSet: 'Erstellungsdatum',
                    dateUpdated: 'Letzte Änderung',
                    hide: 'Nicht anzeigen für',
                    costUnitPaymentId: 'ID',
                    paymentType: 'Art der Zahlung',
                    description: 'Bemerkung',
                    isPaymentAdvice: 'ist Zahlungsavis',
                    workUnitsPerHour: 'AW pro Stunde',
                    bodyWorkWorkUnits: 'AW (Karosserie)',
                    bodyWorkHourlyRate: 'Stundensatz (Karosserie)',
                    bodyWorkTotal: 'Summe (Karosserie)',
                    lacquerWorkUnits: 'AW (Lackierung)',
                    lacquerHourlyRate: 'Stundensatz (Lackierung)',
                    lacquerTotal: 'Summe (Lackierung)',
                    lacquerMaterial: 'Lackmaterial',
                    sparePartsTotal: 'Ersatzteile Summe',
                    additionalCosts: 'Nebenkosten',
                },
                formatters: {
                    dateReceipt: formatDate,
                    dateSet: formatDateTime,
                    dateUpdated: formatDateTime,
                    amountNet: formatCurrencyCents,
                    amountGross: formatCurrencyCents,
                    amountVat: formatCurrencyCents,
                    amountCopayment: formatCurrencyCents,
                    bodyWorkHourlyRate: formatCurrencyCents,
                    bodyWorkTotal: formatCurrencyCents,
                    lacquerHourlyRate: formatCurrencyCents,
                    lacquerTotal: formatCurrencyCents,
                    lacquerMaterial: formatCurrencyCents,
                    sparePartsTotal: formatCurrencyCents,
                    additionalCosts: formatCurrencyCents,
                    vatRate: (value) => value ? `${value}%` : null,
                },
            };
        },
        methods: {
            loadCostUnitDraft() {
                this.isLoading = true;
                recordRepository.loadCostUnitDraftDetail(this.recordId, this.costUnitDraftId).then(
                    (costUnitDraft) => {
                        this.costUnitDraft = costUnitDraft.data.attributes;
                        this.hideForGroupValues = costUnitDraft.data.attributes.hide;
                        delete this.costUnitDraft.hide;
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            },
            reset() {
                this.costUnitDraft = null;
                this.isLoading = true;

                this.$emit('close');
            },
        },
    }
</script>
